/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';
import SiteLinks from './SiteLinks';
import TermsAndConditions from './TermsAndConditions';
import { IldsFooterProps } from '../lds-footer.data';

export const FooterLinks: React.FC<IldsFooterProps> = ({
    salesAndRefundPolicy,
    Links,
    resources,
    config,
    impressum,
    impressumTitle,
    salesTitle,
    onClick,
    context
}) => {
    return (
        <div className='footerLinks'>
            <SiteLinks Links={Links} />
            <TermsAndConditions
                salesAndRefundPolicy={salesAndRefundPolicy}
                resources={resources}
                config={config}
                impressum={impressum}
                salesTitle={salesTitle}
                impressumTitle={impressumTitle}
                onClick={onClick}
            />
            <div
                className={context.request.telemetryPageName === 'Terms and conditions' ? 'terms-footer-info' : 'footer-info'}
                dangerouslySetInnerHTML={{ __html: config.footerInfo || '' }}
            />
        </div>
    );
};
